import { Grid, makeStyles } from '@material-ui/core';
import { useGetRootNodes } from 'apollo/queries/Nodes';
import AttributesEditor from 'components/molecules/manager/AttributesEditor';
import ModelSelector from 'components/molecules/manager/ModelSelector';
import TreeView from 'components/molecules/manager/TreeView';
import { ModelContext } from 'context/model/ModelContext';
import React, { useContext, useEffect, useState } from 'react';
import { INode } from 'ts/interfaces';
const useStyles = makeStyles(() => ({
    divider: {
        borderLeft: '1px solid #eaeaea',
        height: 'calc(100vh - 75px)',
        padding: ' 0 25px',
    },
}));

const Manager = () => {
    const classes = useStyles();
    const [nodeId, setNodeId] = useState<number | null>();
    const [modelId, setModelId] = useState<number | null>();
    const { data: { nodes } = {} } = useGetRootNodes();
    const [parentId, setParentId] = useState<string>();
    const { state } = useContext(ModelContext);

    const handleNodeClick = (id: number | null, parentId: string) => {
        setNodeId(id);
        setParentId(parentId);
    };

    const handleModelSelection = (model: number | null) => {
        setModelId(model);
    };

    useEffect(() => {
        if (+state.currentModel !== modelId) {
            setModelId(+state.currentModel);
        }
    }, [state.currentModel]);

    if (!nodes?.length) {
        return <h1>Fetching data</h1>;
    }
    return (
        <ModelContext.Consumer>
            {() => (
                <Grid container>
                    <Grid item xs={12}>
                        {nodes && <ModelSelector setModel={handleModelSelection} nodes={nodes} />}
                    </Grid>
                    <Grid item xs={6}>
                        {modelId ? (
                            <>
                                <TreeView
                                    handleNodeClick={handleNodeClick}
                                    rootNode={nodes.find((node: INode) => node.id === modelId || +node.id === modelId)}
                                />
                            </>
                        ) : null}
                    </Grid>
                    <Grid item xs={6}>
                        {nodeId ? (
                            <div className={classes.divider}>
                                <AttributesEditor id={+nodeId} parentId={parentId} />
                            </div>
                        ) : null}
                    </Grid>
                </Grid>
            )}
        </ModelContext.Consumer>
    );
};

export default Manager;
